module.exports = __webpack_public_path__ + "img/desc2.7c7e7102.jpg";